export default __webpack_public_path__ + "static/media/euractiv.c4bae76d.png";